module.exports = __webpack_public_path__ + "static/media/NotoSansKR-Thin.5dac92ef.ttf";